import { AnimatePresence, motion } from 'framer-motion';
import isEmpty from 'lodash/isEmpty';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { BalanceState, BETSType, CouponState, State } from 'shared/interface/index';

import { ActionType } from 'api/betslipAnalytics.api';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { useBetslipAnalytics } from 'shared/hooks/useBetslipAnalytics';
import { addBet } from 'shared/store/coupon.action';
import { setAllBets } from 'shared/util/utility';

import './styles.scss';

interface CouponUndoButtonProps {
	deleteTemporaryBets: () => void;
	temporaryBets: any;
	bets: BETSType;
	balanceData: BalanceState;
	isBetslipEmpty: boolean;
	isRestoringBets: boolean;
	handleIsRestoringBets: (isRestoring: boolean) => void;
	className?: string;
}

const CouponUndoButton = ({
	className,
	temporaryBets,
	deleteTemporaryBets,
	bets,
	isBetslipEmpty,
	isRestoringBets,
	handleIsRestoringBets,
}: CouponUndoButtonProps) => {
	const { t } = useTranslation();
	const history = useHistory();
	const { addAction } = useBetslipAnalytics();
	const dispatch = useDispatch();
	const coupon = useSelector<State, CouponState>((state) => state.coupon);
	const analytics = useSelector((state: State) => state.coupon.analytics);

	const handleOnClickUndoBtn = () => {
		if (!isEmpty(temporaryBets)) {
			dispatch(
				addBet({
					...temporaryBets,
					...setAllBets(
						{ ...temporaryBets, bonusBet: false, isFreeBetSelected: false, freebetId: null, freeBetStack: null },
						temporaryBets,
						dispatch,
						coupon,
						analytics,
						t,
					),
				}),
			);
		}
		temporaryBets.outcomes.forEach((item: any) => {
			addAction(item, `${history.location.pathname}/${history.location?.hash}`, ActionType.ADD);
		});
		handleIsRestoringBets(false);
	};

	useEffect(() => {
		if (bets.outcomes.length !== 0 && bets.outcomes.length < temporaryBets?.outcomes?.length) {
			handleIsRestoringBets(false);
		}
	}, [bets, temporaryBets?.outcomes?.length]);

	useEffect(() => {
		let timer: NodeJS.Timeout;
		if (isRestoringBets) {
			timer = setTimeout(() => {
				handleIsRestoringBets(false);
				deleteTemporaryBets();
			}, 5000);
		}
		return () => clearTimeout(timer);
	}, [isRestoringBets]);

	return (
		<>
			{isBetslipEmpty && (
				<AnimatePresence>
					<motion.button
						initial={{ opacity: 1 }}
						animate={{ opacity: 0 }}
						exit={{ opacity: 1 }}
						transition={{ duration: 5 }}
						className={`couponUndoButton__button ${className}`}
						onClick={() => handleOnClickUndoBtn()}
						data-cy="betslip-restore-bets"
					>
						{t('backC')}
					</motion.button>
				</AnimatePresence>
			)}
		</>
	);
};

export default CouponUndoButton;
